import { backendApi } from "../dynamicBAseQuery";

export const NewReferralsApi=backendApi.injectEndpoints({
    overrideExisting:true,
    endpoints:(builder)=>({
        NewReferral:builder.mutation({
            query:(args)=>({
                method:"POST",
                url:"NewReferral",
                params:args
            })
        }),

    })
})

export const {
    useNewReferralMutation,
   
}=NewReferralsApi